import React, { createContext, useState, useContext } from 'react';

// Create the context
const ClientContext = createContext();

// Create a provider component
export const ClientProvider = ({ children }) => {
    const [client, setClient] = useState(null);

    return (
        <ClientContext.Provider value={{ client, setClient }}>
            {children}
        </ClientContext.Provider>
    );
};

// Create a custom hook to use the ClientContext
export const useClient = () => {
    return useContext(ClientContext);
};